export { CategoryBrowsePopularTimes } from './CategoryBrowsePopularTimes';
import { CategoryBrowsePopularTimes } from './CategoryBrowsePopularTimes';

export default CategoryBrowsePopularTimes;
